import React from 'react';
import { FieldProps, useRecordContext } from 'react-admin';
import { Chip, Stack } from '@mui/material';
import { RuleAdjustmentRecord, SelectOption } from '../types';

interface OwnProps {
    exchanges: SelectOption[];
}

const ApplyFor = ({ exchanges }: FieldProps & OwnProps) => {
    const record = useRecordContext<RuleAdjustmentRecord>();
    let exchangeValue = record?.applyfor?.split(',')?.filter((e: string) => e !== '');

    if (!exchangeValue || exchangeValue.length === 0)
        return <></>;
    else return (
        <Stack direction='row' spacing={1}>
            {exchangeValue.map((e: string) => (
                <Chip key={e} label={exchanges.find((ex) => ex.id === e)?.name} />
            ))}
        </Stack>
    );
};

export default React.memo(ApplyFor);